import { apiClient } from '@/lib/api.ts'

export function getUserSettings() {
  return apiClient.get('/settings/user')
}

export function updateUserSettings(data: Record<string, unknown>) {
  return apiClient.put('/settings/user', data)
}

export function getSystemSettings() {
  return apiClient.get<Record<string, string>>('/settings/system')
}

export function updateSystemSettings(data: Record<string, unknown>) {
  return apiClient.put('/settings/system', data)
}

export function getDevModeModules() {
  return apiClient.get<{ modules?: string[] }>('/settings/dev-mode-modules')
}

export function setDevModeModule(moduleId: string, enabled: boolean) {
  return apiClient.put('/settings/dev-mode-modules', { moduleId, enabled })
}
